import React from 'react';
import { StatusVariant } from '@/enums/status-variant';

interface StatusMessageProps {
  children: React.ReactNode;
  centered?: boolean;
  variant?: StatusVariant;
}

export const StatusMessage: React.FC<StatusMessageProps> = ({
  children,
  centered = true,
  variant = StatusVariant.ERROR,
}) => {
  const textAlign = centered ? 'text-center' : 'text-left';
  const textColor =
    variant === StatusVariant.ERROR ? 'text-error-primary' : 'text-primary';

  return (
    <div className='flex flex-col gap-1'>
      <p className={`${textColor} ${textAlign}`}>{children}</p>
    </div>
  );
};
